import React from "react";
import { useQuery } from "@tanstack/react-query";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { HipTasksOverview } from "./HipTasksOverview";

const REFETCH_INTERVAL = 3000;

interface HipTasksOverviewWrapperProps {
  readonly loadData: boolean;
  readonly closeDialog: () => void;
}

export function HipTasksOverviewWrapper({
  loadData,
  closeDialog,
}: HipTasksOverviewWrapperProps): React.JSX.Element {
  const { knopClient } = useKnopClient();
  const { data, error, isLoading } = useQuery({
    enabled: loadData,
    queryKey: ["hip-tasks"],
    queryFn: () => knopClient.getHipTasks(),
    refetchInterval: REFETCH_INTERVAL,
    // Used to prevent the page from rerendering each time new data is fetched.
    structuralSharing: (oldData, newData) =>
      JSON.stringify(oldData) === JSON.stringify(newData) ? oldData : newData,
  });

  if (error) return <ErrorState />;
  return (
    <HipTasksOverview
      hipTasks={data?.hipTasks ?? []}
      hipClient={knopClient}
      isLoading={isLoading}
      closeDialog={closeDialog}
    />
  );
}
